import { Box, CircularProgress, Fade } from "@mui/material";
import { makeStyles } from "@mui/styles";
import LoadingAnimation from "../elements/LoadingAnimation";

const useStyles = makeStyles((theme) => ({
	loading: {
		width: "100%",

		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 0,
	},
}));

export default function Loading({ loading, children, height }) {
	const classes = useStyles();
	return (
		<Box style={{ width: "100%", height: "100%" }}>
			{!loading ? (
				<Fade in={!loading}>
					<div style={{ width: "100%", height: "100%" }}>
						{children}
					</div>
				</Fade>
			) : (
				<Box
					className={classes.loading}
					style={{ height: height ?? 200 }}
				>
					<Fade in={loading}>
						<div>
							<LoadingAnimation />
						</div>
					</Fade>
				</Box>
			)}
		</Box>
	);
}
